import IRPWorkbookProvider from './IRPWorkbookProvider';
import IRPWorkbookComponent from './IRPWorkbook.component';
import React from 'react';
import {IntegratedRiskPicture} from '../../../../../@types/integrated-risk-picture';

/**
 * Props for the wrapped IRP Workbook
 */
interface IRPWorkbookProps {
    integratedRiskPicture?: IntegratedRiskPicture;
    isActive?: boolean;
}

/**
 * Main export that wraps the workbook component with necessary providers.
 * This is the component that should be imported and used by parent components.
 */
const IRPWorkbook: React.FC<IRPWorkbookProps> = ({ integratedRiskPicture, isActive: _isActive }) => {
    return (
        <IRPWorkbookProvider integratedRiskPicture={integratedRiskPicture}>
            <IRPWorkbookComponent />
        </IRPWorkbookProvider>
    );
};

// Export the wrapped component as default
export default IRPWorkbook;

// Also export the individual components for testing purposes
export { IRPWorkbookProvider, IRPWorkbookComponent };
export { useIRPContext } from './IRPWorkbookProvider';